import { notification } from 'antd';

// Configure notification globally
notification.config({
  placement: 'topRight', // default placement
});

const addNotificationSuccess = (message) => {
  notification.success({
    message: (
      <div dangerouslySetInnerHTML={{ __html: message }} />
    ),
  });
};
const addNotificationError = (err) => {
  notification.error({
    message: (
      <div dangerouslySetInnerHTML={{ __html: err }} />
    ),
  });
};

export default { addNotificationSuccess, addNotificationError };